import React from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import PursuitLeadePastForecast from '@pages/forecast/pastForecast/plPastForecast';
import GcspPastForecast from '@pages/forecast/pastForecast/gcspPastForecast';
import MslPastForecast from '@pages/forecast/pastForecast/mslPastForecast';
import { Current_User } from '@recoil/recoil';

const PastForecast = () => {
  const location = useLocation();
  const data = location.state;
  const currentUser = useRecoilValue(Current_User);

  return (
    <>
      {' '}
      {data !== null && currentUser !== null && currentUser.role === 'PL' ? (
        <PursuitLeadePastForecast data={data}></PursuitLeadePastForecast>
      ) : null}
      {data !== null && currentUser !== null && currentUser.role === 'GCSP' ? (
        <GcspPastForecast data={data}></GcspPastForecast>
      ) : null}
      {data !== null && currentUser !== null && currentUser.role === 'MSL' ? (
        <MslPastForecast data={data}></MslPastForecast>
      ) : null}
    </>
  );
};

export default PastForecast;
